import React from 'react'
import { isEmpty } from 'lodash'
import { IconCheck, IconAlertTriangle } from '@tabler/icons-react'

import { SpinningLoader } from '@/components/interactions/SpinningLoader'
import { TOOL_STATUSES } from '../kodi.constants'

export const KodiToolMessage = ({ message }) => {
  // While the tool runs, prefer its latest live progress message (e.g.
  // "Analyzing 100 calls… 40%") over the static rationale.
  const label =
    message.status === TOOL_STATUSES.EXECUTING && !isEmpty(message.progressMessage)
      ? message.progressMessage
      : message.rationale

  const renderStatusIcon = () => {
    if (message.isError) {
      return (
        <IconAlertTriangle
          size={14}
          className="cowork-tool-call__icon cowork-tool-call__icon--error"
        />
      )
    }
    if (message.status === TOOL_STATUSES.COMPLETE) {
      return (
        <IconCheck size={14} className="cowork-tool-call__icon cowork-tool-call__icon--complete" />
      )
    }
    return (
      <span className="cowork-tool-call__icon cowork-tool-call__icon--running">
        <SpinningLoader size={14} />
      </span>
    )
  }

  return (
    <div className="cowork-tool-call">
      <div className="cowork-tool-call__header">
        {renderStatusIcon()}
        <span className="cowork-tool-call__name">{label}</span>
      </div>
    </div>
  )
}
